import http from '../utils/http';
import {
  SET_SINGLE_JOB,
  SET_MATERIAL_NUMBER_OPTIONS,
  SEARCHED_TEAM_MEMBERS,
  CLEAR_JOB,
  CLEAR_MATERIAL_NUMBER_OPTIONS,
  SET_INITIAL_WARRANTY_CODE_OPTIONS,
  DELETE_SINGLE_JOB,
} from '../constants/actionTypes';
import { setFeedbackAction } from './feedback';
import { ERROR_CODE } from '../constants/errorCodes';
import {
  addTeamMemberUrl,
  approveActionUrl,
  downloadAllPicturesUrl,
  downloadSectionPicturesUrl,
  getMaterialNumbersUrl,
  getInitialWarrantyCodesUrl,
  editInitialWarrantyCodeUrl,
  proposeWarrantyUrl,
  editTechnicalWarrantyProposalUrl,
  deleteTechnicalWarrantyProposalUrl,
  amendApprovedTechnicalWarrantyDecisionUrl,
  deleteApprovedTechnicalWarrantyDecisionUrl,
  amendCommercialDecisionUrl,
  deleteCommercialDecisionUrl,
  rateTechnicalDecisionUrl,
  reclassifyTechnicalDecisionUrl,
  removeTeamMemberUrl,
  reopenJobUrl,
  requestReportApprovalUrl,
  requestReportLevelUrl,
  searchTeamMemberUrl,
  setEquipmentSerialNumberUrl,
  setMaterialNumberUrl,
  setStatusUrl,
  setPriceUrl,
  setReleaseMethodUrl,
  chooseReleaseMethodUrl,
  jobUrl,
  verifyJobUrl,
  warrantyDateUrl,
  deleteImportedJobUrl,
  blobServiceUrl,
  getJobByNotificationNumberUrl,
} from '../constants/urls';
import { BlobServiceClient } from '@azure/storage-blob';
import Zip from 'jszip';

export const setSingleJob = job => ({ type: SET_SINGLE_JOB, payload: job })

const deleteSingleJob = () => ({ type: DELETE_SINGLE_JOB });

const setSearchedMembersAction = membersArray => ({ type: SEARCHED_TEAM_MEMBERS, payload: membersArray });

const setMaterialNumberOptionsAction = optionsArray => ({ type: SET_MATERIAL_NUMBER_OPTIONS, payload: optionsArray });

const setInitialWarrantyCodeOptionsAction = optionsArray => ({ type: SET_INITIAL_WARRANTY_CODE_OPTIONS, payload: optionsArray });

const clearMaterialNumberOptionsAction = () => ({ type: CLEAR_MATERIAL_NUMBER_OPTIONS });

const clearJobAction = () => ({ type: CLEAR_JOB });

export const getSingleJob = jobId =>
  async dispatch => {
    try {
      const { data: response } = await http.get(jobUrl(jobId));

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const getSingleJobByNotificationNumber = notificationNumber =>
  async dispatch => {
    try {
      const { data: response } = await http.get(getJobByNotificationNumberUrl(notificationNumber));

      dispatch(setSingleJob(response.data));
      return response.data.id;
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

// level: Number
export const requestReportLevel = (jobId, data) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(requestReportLevelUrl(jobId), data);

      dispatch(setSingleJob(response.data));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const requestReportApproval = jobId =>
  async dispatch => {
    try {
      const { data: response } = await http.post(requestReportApprovalUrl(jobId));

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

// proposal: Object: { decision: Boolean, proposal: String }
export const proposeWarranty = (jobId, warranty, proposal) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(proposeWarrantyUrl(jobId, warranty), proposal);

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const editTechnicalWarrantyProposal = (jobId, actionRequestId, editedProposalData) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(editTechnicalWarrantyProposalUrl(jobId, actionRequestId), editedProposalData);
      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const deleteTechnicalWarrantyProposal = (jobId, actionRequestId) =>
  async dispatch => {
    try {
      const { data: response } = await http.delete(deleteTechnicalWarrantyProposalUrl(jobId, actionRequestId));
      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const amendApprovedTecnicalWarrantyProposal = (jobId, amendedData) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(amendApprovedTechnicalWarrantyDecisionUrl(jobId), amendedData);
      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const deleteApprovedTecnicalWarrantyProposal = (jobId) =>
  async dispatch => {
    try {
      const { data: response } = await http.delete(deleteApprovedTechnicalWarrantyDecisionUrl(jobId));
      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const amendCommercialDecision = (jobId, amendedData) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(amendCommercialDecisionUrl(jobId), amendedData);
      dispatch(setSingleJob(response.data));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const deleteCommercialDecision = (jobId) =>
  async dispatch => {
    try {
      const { data: response } = await http.delete(deleteCommercialDecisionUrl(jobId));
      dispatch(setSingleJob(response.data));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const reopenJob = jobId =>
  async dispatch => {
    try {
      const { data: response } = await http.post(reopenJobUrl(jobId));

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const approveCommercialDecisionAction = (jobId, action, proposalId, status, reason) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(approveActionUrl(jobId, action, proposalId), { status, reason });
      dispatch(setSingleJob(response.data))
    } catch (e) {
        const serverMessage = e && e.response && e.response.data && (
          (e.response.data.error && e.response.data.error.message) || e.response.data.message
        );
        let mappedKey = null;
        if (serverMessage === 'User does not have high enough commercial decision limit to approve/deny this request') {
          mappedKey = ERROR_CODE.LIMIT_REACHED;
        }
        dispatch(setFeedbackAction(mappedKey || serverMessage || e.message));
    }
  }

export const approveAction = (jobId, action, proposalId, status, reason) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(approveActionUrl(jobId, action, proposalId), { status, reason });

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const reclassifyTechnicalDecision = (jobId, data) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(reclassifyTechnicalDecisionUrl(jobId), data);

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const rateTechnicalDecision = (jobId, requestId, data) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(rateTechnicalDecisionUrl(jobId, requestId), data);

      dispatch(setSingleJob(response.data.job))

      dispatch(setFeedbackAction(response.data.message));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

// statusArr: Array of Objects: { status: String, value: String }
export const setStatus = (jobId, statusArr) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(setStatusUrl(jobId), statusArr);

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

// price: number
export const setPrice = (jobId, price) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(setPriceUrl(jobId), { price });

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

// method: string
export const setReleaseMethod = (jobId, method, proposedDate, partNumbers, shipToAddress) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(setReleaseMethodUrl(jobId), { method, proposedDate, partNumbers, shipToAddress });
      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }


export const chooseReleaseMethod = (jobId, method, proposedDate, partNumbers, shipToAddress) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(chooseReleaseMethodUrl(jobId), { method, proposedDate, partNumbers, shipToAddress });

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

// warrantyType: 'start' | 'end'
export const setWarrantyDate = (jobId, warrantyType, date) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(warrantyDateUrl(jobId, warrantyType), { date });

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const searchTeamMember = (jobId, query) =>
  async dispatch => {
    try {
      const { data: response } = await http.get(searchTeamMemberUrl(jobId, encodeURIComponent(query)));

      dispatch(setSearchedMembersAction(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const clearSearch = () => dispatch => dispatch(setSearchedMembersAction(null))

export const addTeamMember = (jobId, data) =>
  async dispatch => {
    try {
      const { data: response } = await http.post(addTeamMemberUrl(jobId), data);

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const removeTeamMember = (jobId, userId) =>
  async dispatch => {
    try {
      const { data: response } = await http.delete(removeTeamMemberUrl(jobId, userId));

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const setEquipmentSerialNumber = (jobId, equipmentNumber) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(setEquipmentSerialNumberUrl(jobId, equipmentNumber));

      dispatch(setSingleJob(response.data));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const getMaterialNumberOptions = customerCenter =>
  async dispatch => {
    try {
      const { data: response } = await http.get(getMaterialNumbersUrl(customerCenter));

      dispatch(setMaterialNumberOptionsAction(response.data.materialNumber));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const setMaterialNumber = (jobId, materialNumber) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(setMaterialNumberUrl(jobId, materialNumber));

      dispatch(setSingleJob(response.data));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const verifyJob = jobId =>
  async dispatch => {
    try {
      const { data: response } = await http.put(verifyJobUrl(jobId));

      dispatch(setSingleJob(response.data))
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const deleteJob = jobId =>
  async dispatch => {
    try {
      await http.delete(jobUrl(jobId));

      dispatch(deleteSingleJob())
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const deleteImportedJob = jobId =>
  async dispatch => {
    try {
      await http.delete(deleteImportedJobUrl(jobId));

      dispatch(deleteSingleJob())
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const getInitialWarrantyCodes = () =>
  async dispatch => {
    try {
      const { data: response } = await http.get(getInitialWarrantyCodesUrl());

      dispatch(setInitialWarrantyCodeOptionsAction(response.data.initialWarrantyCode));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const editInitialWarrantyCode = (jobId, answer) =>
  async dispatch => {
    try {
      const { data: response } = await http.put(editInitialWarrantyCodeUrl(jobId), answer);

      dispatch(setSingleJob(response.data));
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const downloadAllPictures = (jobId, section = null) =>
  async dispatch => {
    try {
      const result = section
        ? (await http.get(downloadSectionPicturesUrl(jobId, section))).data.data
        : (await http.get(downloadAllPicturesUrl(jobId))).data.data;
      const {
        accountName,
        sasToken,
        containerName,
        blobs,
        archiveFileName,
      } = result || {};

      const blobServiceContainerClient = new BlobServiceClient(blobServiceUrl(accountName, sasToken))
        .getContainerClient(containerName);

      const zip = new Zip();

      await Promise.all(
        blobs.map(blob => new Promise(async (resolve, reject) => {
          const downloadedBlob = await blobServiceContainerClient.getBlobClient(blob.blobName).download();
          resolve(zip.file(blob.fileName, await downloadedBlob.blobBody))
        }))
      );

      const reportLink = document.querySelector('#download');
      reportLink.href = URL.createObjectURL(await zip.generateAsync({ type: 'blob' }));
      reportLink.setAttribute('download', archiveFileName);
      reportLink.click();
      reportLink.href = '';
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const downloadSectionPictures = (jobId, section) =>
  async dispatch => {
    try {
      const str2bytes = str => {
        let bytes = new Uint8Array(str.length);
        for (let i = 0; i < str.length; i++) {
          bytes[i] = str.charCodeAt(i);
        }
        return bytes;
      };

      const response = await http.get(downloadSectionPicturesUrl(jobId, section));
      const fileName = response.headers['content-disposition'].split('"')[1];
      const file = new Blob([str2bytes(response.data)]);

      const reportLink = document.querySelector('#download');
      reportLink.href = URL.createObjectURL(file);
      reportLink.setAttribute('download', fileName);
      reportLink.click();
      reportLink.href = "";
    } catch (e) {
      dispatch(setFeedbackAction(e.message));
    }
  }

export const clearMaterialNumberOptions = () => dispatch => dispatch(clearMaterialNumberOptionsAction());

export const clearJob = () => dispatch => dispatch(clearJobAction());



// WEBPACK FOOTER //
// ./src/actions/singleJob.js